import React, { useState,useContext } from 'react';
import { ModalContainer,UIcon,IconContainer ,
    MainContentContainer1,SubmitContainer,
    StyleButton,StyleInput,StyleLabel
} from '../Modal/CreateAdminUser';
import { FilterDropDown } from '../../../../ui-components';
import { useSettingModal } from '../../../../hooks/Context';
import { FetchSingleData } from '../../../../hooks/FetchData';
import apiCall from '../../../../utils/apiCall';
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { NotificationContext } from '../../../../providers/notification';


const CreateInduction = () => {
    const InductionId = 0;
    const [InductionName,setInductionName] = useState<string>('');
    const [InductionVenue,setInductionVenue] = useState<string>('');
    let  InductionDate:any = '';
    const [date,setDate] = useState<any>(null);
    const [time,setTime] = useState<any>(null);
    const [loading,setLoading] = useState<boolean>(false);

    const options = [
        {name:'Induction',val:'1'},
        {name:'Induction',val:'2'}
    ]

    const {showNotification } = useContext(NotificationContext);
    const {setShowModal} = useSettingModal();
    const queryClient = useQueryClient()

    const handleCreateInduction = async() =>{
        InductionDate = `${date}T${time}`;
        const data = {
          InductionDate: new Date(InductionDate),
          InductionName,
          InductionVenue,
          InductionId,
          IsActive:false
        }

        setLoading(true);
        return await (await apiCall().post('/SetUp/CreateUpdateInduction', data)).data;
    }
     
    const AddInductionMutation = useMutation(handleCreateInduction,{
      
      onSuccess:()=>{
        showNotification({
          type:'success',
          message: 'Induction Successfully Created',
        })
        setShowModal(false);
        setLoading(false);
        queryClient.invalidateQueries(['all-Induction']);
      },
     
      onError(error:any, variables, context) {
        setShowModal(false);
        showNotification({
          type:'error',
          message: error.message,
        })
        setLoading(false);
      },

      
    })

    const handleForm = (e:any) => {
      e.preventDefault();

      if(InductionName?.length === 0) {
        showNotification({
          type: 'error',
          message: 'Induction name is required'
        })
        return;
      }

      if(InductionVenue?.length === 0) {
        showNotification({
          type: 'error',
          message: 'Induction venue is required'
        })
        return;
      }

      if(date ===  null) {
        showNotification({
          type: 'error',
          message: 'Induction date is required'
        })
        return;
      }

      if(time === null) {
        showNotification({
          type: 'error',
          message: 'Induction time is required'
        })
        return;
      }

      if(date && time && InductionName && InductionVenue){
        AddInductionMutation.mutate();
      }
    }

  return (
    <ModalContainer>
    <div>
      <div>
        <div>
          <IconContainer><UIcon /></IconContainer>
          <span>Induction</span>
        </div>
      </div>
      <MainContentContainer1 onSubmit={handleForm}>
        <StyleLabel style={{width:'100%'}}>
            <span>Induction Type</span>
            <FilterDropDown replace='true' options={options} text='Induction type' border="1px solid lightgray" bg='white' />

        </StyleLabel>
        <StyleLabel>
            <span>Name</span>
            <StyleInput onChange={(e:any)=>setInductionName(e.target.value)} placeholder='Name' />
        </StyleLabel>
        <StyleLabel>
            <span>Venue</span>
            <StyleInput onChange={(e:any)=>setInductionVenue(e.target.value)} placeholder='Venue' />
        </StyleLabel>
        <StyleLabel>
            <span>Date</span>
            <StyleInput onChange={(e:any)=>setDate(e.target.value)} type='date' />
        </StyleLabel>
        <StyleLabel>
            <span>Time</span>
            <StyleInput onChange={(e:any)=>setTime(e.target.value)} type='time' />
        </StyleLabel>
        <SubmitContainer>
            <span onClick={()=>setShowModal(false)}>Cancel</span>
            <StyleButton >
                {!loading ?'Submit':'Loading...'}
            </StyleButton>
        </SubmitContainer>

      </MainContentContainer1>
      </div>
    </ModalContainer>
  )
}

export default CreateInduction